import { render, staticRenderFns } from "./exception.vue?vue&type=template&id=068e92a6&scoped=true"
import script from "./exception.vue?vue&type=script&lang=ts"
export * from "./exception.vue?vue&type=script&lang=ts"
import style0 from "./exception.vue?vue&type=style&index=0&id=068e92a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e92a6",
  null
  
)

export default component.exports